import { render, staticRenderFns } from "./Boleto.vue?vue&type=template&id=4ca244b8&"
import script from "./Boleto.vue?vue&type=script&lang=js&"
export * from "./Boleto.vue?vue&type=script&lang=js&"
import style0 from "./Boleto.vue?vue&type=style&index=0&id=4ca244b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports